<form [formGroup]="citiesForm" (ngSubmit)="submitForm(citiesForm,$event)">
    <adc-row>
        <adc-column col-desktop="12" col-tablet="12" col-phone="4">
            (<span aria-hidden="true" class="icon-required"></span> {{ 'global.required' | aai18n }}
            <span class="sr-text">{{ 'global.requiredIndicatorHidden' | aai18n }}</span>)
        </adc-column>
        <adc-column>
            <adc-notification title="{{ 'error:ERRCODE408.title' | aai18n }}" kind="error" *ngIf="errorCount > 0" class="notification-container">
                <span>
                    {{ errorMessage.helperText }} <a href="javascript:void(0)" (click)="focusFirstError()" class="error-link">{{ errorMessage.linkText }}</a>
                </span>
            </adc-notification>
        </adc-column>
    </adc-row>
    <adc-row>
    <adc-column col-desktop="4" col-tablet="4" col-phone="4">
        <adc-auto-complete #originAirport
                    (keyup)="filterAirports($event)"
                    (keydown)="keyPressFilter('originAirport',$event)"
                    config="{{airportCodesFiltered}}"
                    formControlName="originAirport"
                    ngDefaultControl
                    placeholder="{{ 'booking.toPlaceholder' | aai18n }}"
                    id="originAirportInput"
                    attr.label-text="{{ 'global.from' | aai18n }}"
                    attr.up-down-translation="{{ 'global.autoComplete.instructions' | aai18n }}"
                    attr.result-available-translation="{{ 'global.autoComplete.resultAvailable' | aai18n }}"
                    attr.results-available-translation="{{ 'global.autoComplete.resultsAvailable' | aai18n }}"
                    attr.hovered-translation="{{ 'global.autoComplete.hovered' | aai18n }}"
                    attr.option-translation="{{ 'global.autoComplete.option' | aai18n }}"
                    attr.clear-translation="{{ 'global.autoComplete.clear' | aai18n }}"
                    attr.of-translation="{{ 'global.autoComplete.of' | aai18n }}"
                    (click)="filterAirports($event)"
                    (focusout)="autoSelectAirport('originAirport',$event)"
                    required>
            <adc-button-icon slot="button-icon" icon="technology:gps" kind="ghost" size="sm" (click)="locate('originAirport')" labelText="{{ 'booking.fromCurrentLocationPlaceholder' | aai18n }}"></adc-button-icon>
        </adc-auto-complete>
    </adc-column>
    <adc-column col-desktop="4" col-tablet="4" col-phone="4">
        <adc-auto-complete #destinationAirport
                    (keyup)="filterAirports($event)"
                    (keydown)="keyPressFilter('destinationAirport',$event)"
                    config="{{airportCodesFiltered}}"
                    formControlName="destinationAirport"
                    ngDefaultControl
                    placeholder="{{ 'booking.toPlaceholder' | aai18n }}"
                    id="destinationAirportInput"
                    attr.label-text="{{ 'global.to' | aai18n }}"
                    attr.up-down-translation="{{ 'global.autoComplete.instructions' | aai18n }}"
                    attr.result-available-translation="{{ 'global.autoComplete.resultAvailable' | aai18n }}"
                    attr.results-available-translation="{{ 'global.autoComplete.resultsAvailable' | aai18n }}"
                    attr.hovered-translation="{{ 'global.autoComplete.hovered' | aai18n }}"
                    attr.option-translation="{{ 'global.autoComplete.option' | aai18n }}"
                    attr.clear-translation="{{ 'global.autoComplete.clear' | aai18n }}"
                    attr.of-translation="{{ 'global.autoComplete.of' | aai18n }}"
                    (click)="filterAirports($event)"
                    (focusout)="autoSelectAirport('destinationAirport',$event)"
                    required>
            <adc-button-icon slot="button-icon" icon="technology:gps" kind="ghost" size="sm" (click)="locate('destinationAirport')" labelText="{{ 'booking.toCurrentLocationPlaceholder' | aai18n }}"></adc-button-icon>
        </adc-auto-complete>
    </adc-column>
    <adc-column col-desktop="4" col-tablet="4" col-phone="4">
        <adc-select  #citiesDate  name="travelDate" formControlName="citiesDate" ngDefaultControl *ngIf="dates" attr.label-text="{{ 'flightStatus.date' | aai18n }}">
            <adc-select-item *ngFor="let date of dates"
                [attr.value]=" date.value " selected="{{ date.default ? 'selected' : '' }}" >{{date.item}}</adc-select-item>
        </adc-select>
    </adc-column>
    </adc-row>
    <adc-row>
        <adc-column col-desktop="8" col-tablet="4"></adc-column>
        <adc-column col-desktop="4" col-tablet="4" col-phone="4">
            <adc-button id="citiesSubmitButton" (click)="submitForm(citiesForm,$event)" size="fullwidth">
                {{ 'global.search' | aai18n }}
            </adc-button>
        </adc-column>
    </adc-row>
</form>

<div *ngIf="showFormValue">Submitted Form: {{ submittedForm }}</div>

